import { AuthService } from './auth/auth.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth/auth.service";
var RestsService = /** @class */ (function () {
    function RestsService(http, user) {
        this.http = http;
        this.user = user;
    }
    RestsService.prototype.getPermessi = function () {
        return new Promise(function (resolve, reject) {
            resolve(true);
            /*
      if(_env.debug) console.log('-------------- IN: '  + _env.services_rest_url + 'getPermessi/'+this.user.getUsername());
            this.http.get(_env.services_rest_url + 'getPermessi/'+this.user.getUsername())
                .subscribe( res => {
                    //this.isAuthenticated = res['isAuthenticated'];
                    if(_env.debug) console.log('-------------- RES: '  + JSON.stringify(res));
                    resolve(true); });
                  */
        });
    };
    RestsService.prototype.getPermessiRisorse = function () {
        return new Promise(function (resolve, reject) {
            resolve(true);
            /*
            this.http.get(_env.services_rest_url + 'getPermessiRisorse/'+this.user.getUsername())
                .subscribe( res => {
                    //this.isAuthenticated = res['isAuthenticated'];
                    //https://test.sardegnasira.it/mgu/rest/metodi/getUtente/utenteadmin
                    if(_env.debug) console.log('-------------- RES: '  + JSON.stringify(res));
                    resolve(true); });
      
                    */
        });
    };
    RestsService.ngInjectableDef = i0.defineInjectable({ factory: function RestsService_Factory() { return new RestsService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService)); }, token: RestsService, providedIn: "root" });
    return RestsService;
}());
export { RestsService };
